@if (formSchema()) {
  <div class="flex flex-col gap-y-3">
    @if (formSchema().type === 'object' && formSchema().properties) {
      @for (property of getProperties(formSchema().properties); track property.id) {
        @if (property.type === 'select') {
          <control-select
            [control]="getControl(form(), property.id)"
            [options]="property?.options || []"
            [placeholder]="property.placeholder"
          />
        }
      }
    }

    <ui-button
      classes="w-full bg-blue-400 text-white rounded-md"
      button
      buttonType="primary"
      buttonSize="default"
      [loading]="false"
      [disabled]="!form().valid"
    >
      {{ submitText() }}
    </ui-button>

  </div>
} @else {
  Error loading the form
}
